import { Container, Typography, Box, Grid, Divider, } from '@material-ui/core';
import React, { useEffect } from 'react';
import Aos from 'aos'
import "aos/dist/aos.css"
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import { Helmet } from 'react-helmet';
import Banner from '../../../asset/images/insight/article_thumbnails/banner-evolving-lending-landscape.webp'
import ViewFullWhitepaperNew from '../../../Component/forms/ViewFullWhitepaperNew.js';

import EmployeeProfile from '../../../Component/EmployeeProfile.js';
import ND from '../../../asset/images/team/new/nilanjan_das.webp'
import Whitepaperback from '../../../Component/Whitepaperback.js';
import ViewFullWhitepaperRightForm from '../../../Component/forms/ViewFullWhitepaperRightForm.js';

export default function TrendsAndToDos() {

    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);


    const link = "https://objectstorage.ap-mumbai-1.oraclecloud.com/n/bmexgnkisxsv/b/marketing_dpa/o/WhitepaperTrends%20and%20To-Dos%20for%20SBA%20Lenders%20Defining%20the%20way%20forward%20in%20an%20evolving%20lending%20landscape.%202%20(1).pdf"

    return (
        <>

            <Helmet>
                <meta charset="UTF-8" />
                <title>SBA Lending Trends for 2025: Key Challenges & Future Strategies</title>
                <meta name="description" content="Explore the evolving SBA lending landscape, including challenges, trends, and strategies to ensure success in 2025. Discover what lenders need to do to stay ahead." />
                <link rel="canonical" href="https://www.decimalpointanalytics.com/whitepapers/sba-lenders-trends-2025" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            </Helmet>


            <Box id="whitepaper-new" >
                <Box className='section sec_bg' mt={6}>
                    <Container maxWidth="lg">

                        <Grid container spacing={4} justifyContent='center'>

                            <Grid item lg={7} md={7} sm={6} xs={12} className='grid-custom-12'>
                                <Box >
                                    <Typography variant='h1' className='blue mainhead al_left' style={{ textTransform: 'none' }} gutterBottom>
                                        Trends and To-Dos for SBA Lenders: Defining the way forward in an evolving lending landscape
                                    </Typography>
                                </Box>
                                <Typography variant="h2" className="h4 al_left fw6 mb0">
                                    Prepare for the Future of SBA Lending: Key Insights for 2025
                                </Typography>

                                <Typography variant="h4" className="black al_left fw4 jst">
                                    To stay competitive amid critical changes in SBA lending, it’s essential to leverage technology and automation to streamline processes, mitigate risks, and enhance compliance. This whitepaper highlights key strategies for SBA lenders to adapt and succeed in an evolving landscape.
                                </Typography>

                                <Box className='flx_left' mt={4}>
                                    <ViewFullWhitepaperNew reportby={"Trends and To-Dos for SBA Lenders: Defining the way forward in an evolving lending landscape"} btn_name="Download the whitepaper" link={link} />
                                </Box>

                            </Grid>

                            <Grid item lg={5} md={5} sm={6} xs={12} className='grid-custom-12'>
                                <Box >
                                    <img src={Banner} className='brd8 w100' alt='Banner' />
                                </Box>
                            </Grid>

                        </Grid>
                    </Container>
                </Box>

                <Box className='section w_bg'>
                    <Container maxWidth="lg">
                        <Grid container spacing={5} justifyContent='center' alignItems='flex-start'>


                            <Grid item lg={7} md={7} sm={7} xs={12} className='grid-custom-12'>
                                <Grid container spacing={4} alignItems="flex-start">
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                        <Box>
                                            {/* <Typography variant="h4" className="h4 black">
                                                This whitepaper explores the latest trends in SBA lending, including:
                                            </Typography> */}

                                            <Typography variant='h6' className='black jst' gutterBottom>
                                                This whitepaper explores the latest trends in SBA lending, including:
                                                <ul>
                                                    <li>
                                                        <Typography variant='h6' className='black jst'>
                                                            <strong>Rising Loan Application Volumes:</strong> Understand how increasing demand is reshaping the industry.
                                                        </Typography>
                                                    </li>
                                                    <li>
                                                        <Typography variant='h6' className='black jst'>
                                                            <strong>Operational Bottlenecks & Risk Assessment:</strong> Learn how automation can help lenders streamline operations and enhance decision-making.
                                                        </Typography>
                                                    </li>
                                                    <li>
                                                        <Typography variant='h6' className='black jst'>
                                                            <strong>Compliance and Fraud Prevention:</strong> Discover best practices for improving compliance and reducing fraud in SBA loan processing.
                                                        </Typography>
                                                    </li>
                                                    <li>
                                                        <Typography variant='h6' className='black jst'>
                                                            <strong>The Competitive Landscape:</strong> Get insights on staying ahead of alternative lenders with smarter, tech-driven solutions.
                                                        </Typography>
                                                    </li>
                                                </ul>


                                            </Typography>

                                            <Box pt={1}>

                                                <Typography variant="h2" className="h4 al_left fw6 mb0">
                                                    Ready to navigate the future of SBA lending?
                                                </Typography> 

                                                <Typography variant='h6' className='black jst' gutterBottom>
                                                    Learn how to leverage advanced tools and data to enhance your operations, reduce errors, and boost client satisfaction.
                                                </Typography>
                                            </Box>


                                        </Box>

                                    </Grid>
                                </Grid>

                            </Grid>

                            <Grid item lg={5} md={5} sm={5} xs={12} className='grid-custom-12'>
                                <Box  >
                                    <Box className="web_section whitebx sec_bg" >
                                        <Box className='graybbx2222' mt={2}>
                                            <ViewFullWhitepaperRightForm reportby={"Trends and To-Dos for SBA Lenders: Defining the way forward in an evolving lending landscape"} link={link} />
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>

                            <Grid item lg={12} md={12} sm={21} xs={12} className='grid-custom-12'>
                                <Divider />
                            </Grid>

                            <Grid item lg={12} md={12} sm={21} xs={12} className='grid-custom-12'>
                                <Box >
                                    <EmployeeProfile imgSrc={ND} name={"MR. Nilanjan Das"} designation={"Executive Vice President - Business Development,"} company={"Decimal Point Analytics Pvt. Ltd."} linkedinUrl={"https://www.linkedin.com/in/nilanjan-das-cfa-284ab64/"} />
                                </Box>
                            </Grid>

                            <Grid item lg={4} md={5} sm={5} xs={12} className='grid-custom-12'>
                                <Whitepaperback />
                            </Grid>


                        </Grid>
                    </Container>
                </Box>
            </Box>

        </>
    );
}